import { FormEvent, useState } from "react";
import {
  Button,
  CircularProgress,
  Paper,
  Stack,
  TextField,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

// MDA.Claim.ClaimReference is varchar(100); the API rejects anything longer.
export const MAX_CLAIM_REFERENCE_LENGTH = 100;

interface MdaClaimReferenceSearchProps {
  loading: boolean;
  onSearch: (claimReference: string) => Promise<void>;
}

const MdaClaimReferenceSearch = ({
  loading,
  onSearch,
}: MdaClaimReferenceSearchProps) => {
  const [claimReference, setClaimReference] = useState("");
  const trimmedReference = claimReference.trim();
  const canSearch = Boolean(trimmedReference) && !loading;

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (!canSearch) return;

    await onSearch(trimmedReference);
  };

  return (
    <Paper
      component="form"
      elevation={0}
      onSubmit={handleSubmit}
      sx={{
        border: "1px solid #dfe6f0",
        borderRadius: 1.5,
        p: { xs: 2, sm: 2.5 },
        backgroundColor: "#fff",
      }}
    >
      <Stack
        direction={{ xs: "column", sm: "row" }}
        spacing={2}
        alignItems={{ xs: "stretch", sm: "center" }}
      >
        <TextField
          label="Claim reference"
          placeholder="Enter the exact claim reference"
          value={claimReference}
          onChange={(event) => setClaimReference(event.target.value)}
          size="small"
          fullWidth
          autoFocus
          slotProps={{ htmlInput: { maxLength: MAX_CLAIM_REFERENCE_LENGTH } }}
        />
        <Button
          type="submit"
          variant="contained"
          disabled={!canSearch}
          startIcon={
            loading ? (
              <CircularProgress color="inherit" size={16} />
            ) : (
              <SearchIcon />
            )
          }
          sx={{
            flexShrink: 0,
            bgcolor: "#1769ff",
            borderRadius: 1,
            boxShadow: "none",
            fontWeight: 700,
            px: 2.5,
            textTransform: "none",
            "&:hover": { bgcolor: "#0d5be1", boxShadow: "none" },
          }}
        >
          {loading ? "Searching..." : "Search"}
        </Button>
      </Stack>
    </Paper>
  );
};

export default MdaClaimReferenceSearch;
